module.exports = __webpack_public_path__ + "img/yl3095.4c95f4c7.png";